// extracted by mini-css-extract-plugin
module.exports = {"header":"ManualTimeModal_header__1V9qL","content":"ManualTimeModal_content__2Xc9M"};